<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="180rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span>{{ item.value }}</span>
          <span class="text-primary ml-1 c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="visible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <span :class="['tags-wrap', { s: pay_status === 1 }]" v-if="diff_fee_tag">{{ diff_fee_tag }}</span>
        <span class="tags-wrap" v-if="tags">{{ tags }}</span>
      </div>
      <LineWrapper list column="3">
        <LineItem class="item" v-for="item in list2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
      <template v-if="installmentConfig.length">
        <LineWrapper list column="1">
          <LineItem label="">
            <div style="width: 1000rem">
              <CustomTable :config="installmentConfig" :data="installmentData" border />
            </div>
          </LineItem>
        </LineWrapper>
      </template>
      <template v-if="is_pay">
        <LineWrapper list column="3">
          <LineItem label="实缴金额及方式">
            <div style="width: 700rem">
              <CustomTable :data="data" :config="config" type="gray" />
              <ZuTips class="mt-2" :value="sumAmount" type="info" showIcon />
            </div>
          </LineItem>
        </LineWrapper>
        <LineWrapper labelWidth="160rem">
          <LineItem v-for="item in list4" :key="item.label" :label="item.label" :value="item.value"></LineItem>
        </LineWrapper>
      </template>
    </div>

    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper list column="3">
        <LineItem class="item" v-for="item in list3" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
    </div>
    <Dialog :visible.sync="dialogVisible" title="最高诊断性考试成绩详情" size="large" :showFooter="false">
      <LineWrapper list column="3">
        <LineItem :label="item.label" :value="item.value" v-for="item in dialogList" :key="item.label" labelAlign="right"></LineItem>
      </LineWrapper>
      <div class="pb-2"></div>
      <CustomTable :data="dialogListData1" :config="dialogListConfig1" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
      <CustomTable v-if="dialogListData2.length" :data="dialogListData2" :config="dialogListConfig2" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
    </Dialog>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import CustomTable from '@/components/common/CustomTable'
import ZuTips from '@/components/common/ZuTips'
import http from '@/api'
import { preciseAdd, numberToChinese } from '@/utils'
import ZMainPage from '@/components/common/MainPage.vue'

export default {
  _config: { route: { path: 'look-old', meta: { title: '查看' } } },
  components: { ZMainPage, LineWrapper, LineItem, ImageViewer, Dialog, CustomTable, ZuTips },
  data() {
    return {
      visible: false,
      tags: '',
      dialogVisible: false,
      dialogList: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      data: [],
      config: [],
      installmentConfig: [],
      installmentData: [],
      sumAmount: 0,
      is_pay: 0,
      dialogListData1: [],
      dialogListData2: [],
      dialogListConfig1: [],
      dialogListConfig2: [],
      score_image: '',
      pay_status: '',
      diff_fee_tag: ''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handlePreview(type) {
      if (type === 0) {
        this.visible = true
      } else {
        this.dialogVisible = true
      }
    },
    getData() {
      http({ url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs' }).then((res) => {
        this.tags = res.tag ? res.tag[0]?.name : ''
        this.score_image = res.score_image
        this.pay_status = res.pay_status
        this.diff_fee_tag = res.diff_fee_tag
        const list = [
          { label: '订单编号', value: res.order_number },
          { label: '入账学校', value: res.school },
          { label: res.order_type === 100 ? '订单类型' : '购买服务名称', value: res.order_type === 100 ? res.order_type_name : res.goods_pack_name },

          { label: '学生姓名', value: res.student_name },
          { label: '学生身份证号/护照号', value: res.student_idcard },
          { label: res.order_type === 100 ? '缴费学年' : '报名年级', value: res.order_type === 100 ? res.school_year : res.grade_name },
          ...(res.order_type === 100 ? [
            { label: '就读年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '就读校区', value: res.studying_school_name },
            { label: '购买服务名称/收费项名称', value: res.goods_pack_name },
            { label: '开始收费时间', value: res.charge_at }
          ] : [])
        ]
        if (res.order_type === 2) {
          if (res.max_score_name === '中考') {
            list.push({ label: '中考成绩折算后总分', value: res.max_score })
            list.push({ label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0 })
          } else {
            list.push({ label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1 })
            this.dialogList = [
              { label: '学生姓名', value: res.student_name },
              { label: '学生参考城市', value: res.senior_city },
              { label: '考试名称', value: res.max_score_name },
              { label: '考试总分', value: res.junior_score },
              { label: '折算后考试总分', value: res.max_score }
            ]
            const { diagnose_score_list } = res
            const options = [],
              l1 = diagnose_score_list[0]?.length
            if (l1) {
              for (let i = 0; i < l1; i++) {
                options.push({ label: diagnose_score_list[0][i], value: diagnose_score_list[1][i] })
              }
            }
            let l2 = options.length
            if (l2 > 3) {
              l2 = Math.ceil(l2 / 2)
            }
            const obj1 = { num: '分数' },
              obj2 = { num: '分数' },
              config1 = [{ label: '科目', prop: 'num', type: 'title' }],
              config2 = [{ label: '科目', prop: 'num', type: 'title' }]
            options.forEach((i, index) => {
              if (index < l2) {
                obj1[`k_${index}`] = i.value
                config1.push({ prop: `k_${index}`, label: i.label })
              } else {
                obj2[`k_${index}`] = i.value
                config2.push({ prop: `k_${index}`, label: i.label })
              }
            })
            this.dialogListData1 = [obj1]
            this.dialogListConfig1 = config1
            if (config2.length > 1) {
              const l3 = config1.length - config2.length
              if (l3 > 0) {
                for (let i = 0; i < l3; i++) {
                  config2.push({ prop: `z_${i}`, label: '' })
                }
              }
              this.dialogListData2 = [obj2]
              this.dialogListConfig2 = config2
            }
          }
        }
        this.list1 = list
        const arr = ['否', '是', '部分欠缴']
        this.list2 = [
          { label: res.order_type == 100 ? '应缴金额' : '系统计算应缴总额', value: res.money_answer },
          { label: '是否缴费', value: res.is_pay },
          res.order_type == 100 && res.is_pay === '是' ? { label: '是否分期', value: arr[res.is_by_stages] } : {}
        ]
        if (res.is_pay === '是') {
          this.is_pay = 1
          this.list2.push({ label: res.order_type == 100 ? '实缴总额' : '合计实缴总额', value: res.paid_amount })
          if (res.is_by_stages) {
            this.list2.push({ label: '欠缴金额', value: res.stages_first_money_not_paid, cssStyle: {'grid-column': '2 / -1' } })
            if (res.is_by_stages === 1) {
              this.list2.push({ label: '分期每期应缴金额', value: res?.stages_average_money })
              this.list2.push({ label: '分期期数', value: res.by_stages, cssStyle: { 'grid-column': '2 / -1' } })
              const arr = res.stages_plan || []
              const obj = {}
              const arr1 = arr.map((i, j) => {
                const num =  Number(i.to_pay_price)
                obj[`k${j+1}`] = num
                return { label: numberToChinese(j+1, true)+'期', prop: `k${j+1}`, type: 'title', value: num }
              })
              const len = arr1.length + 1
              const total = arr1.reduce((a, b) => preciseAdd(a, b.value), 0)
              arr1.push({ label: '合计', prop: `k${len}`, type: 'title', value: total })
              obj[`k${len}`] = total
              this.installmentConfig = arr1
              this.installmentData = [obj]
            }
          }
        } else {
          this.list2.push({ label: '驳回原因', value: res.reason, cssStyle: { 'grid-column': '1 / 3' } })
        }
        const { payment_detail = [] } = res
        // 实缴金额及方式 利息减免金额：{{ domain.interest_amount }}
        if (!(payment_detail.length === 1 && Number(payment_detail[0].paid_amount) === 0)) {
          this.data = payment_detail.map((i) => {
            return {
              paid_amount: i.paid_amount,
              payment_method: i.payment_method,
              payer: i.payer,
              payment_at: i.payment_at
            }
          })
          this.config = [
            { prop: 'paid_amount', label: '学生缴费金额', type: 'other' },
            { prop: 'payment_method', label: '学生缴费方式', type: 'other' },
            { prop: 'payer', label: '付款人姓名', type: 'other' },
            { prop: 'payment_at', label: '缴费时间', type: 'other' }
          ]
          const sum = payment_detail.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
          this.sumAmount = `累计实缴金额：${sum}`
        }
        const list4 = []
        if (res.reason) {
          list4.push({ label: '备注', value: res.reason })
        }
        this.list4 = list4
        this.list3 = [
          { label: '操作人', value: res.approval_creator },
          { label: '操作时间', value: res.approval_at, cssStyle: { 'grid-column': '2 / -1' } }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-wrap {
  padding: 2rem 6rem;
  border-radius: 4rem;
  font-size: 12rem;
  color: #f53f3f;
  background-color: #fce5e5;

  &.s {
    color: #4ad999;
    background-color: #e5f9ed;
  }
}
</style>
